export default __webpack_public_path__ + "static/media/title.4d0a64c6.svg";